/* ============================================================================
   Pinksisly · Formatters
   ----------------------------------------------------------------------------
   가격, 상품명, 색상명 표시 포맷을 한 곳에서 관리.
   상품 카드, 카트, 체크아웃 등 어디서나 이 함수만 사용.
   ========================================================================= */

/* ----------------------------------------------------------------------
   PRICE · Argentine standard (thousand-dot, decimal-comma)
   29040  → "$ 29.040"
   68970  → "$ 68.970"
---------------------------------------------------------------------- */

// ARS currency default has minFractionDigits=2; setting only `maximumFractionDigits: 0`
// throws RangeError in some Intl implementations (e.g. older Chromium / Node Intl
// used by react-snap during prerender). Always set both explicitly.
//
// currencyDisplay:"code" prints "ARS 29.040" instead of "$ 29.040". Avoids
// the USD/ARS ambiguity foreign visitors and social previews fall into when
// the symbol is just "$" — same glyph for two different currencies.
const arsFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  currencyDisplay: 'code',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatARS(amount) {
  if (amount == null || !Number.isFinite(Number(amount))) return '—';
  const n = Number(amount);
  // ≤ 0 = data error (admin forgot to set price, or backend returned 0).
  // Showing "$ 0" makes customers think the item is free → fraud / clickbait
  // signals + immediate complaint. Prefer "—" + the operator catches it.
  if (n <= 0) return '—';
  return arsFormatter.format(n);
}

/* ----------------------------------------------------------------------
   PRODUCT NAME · Remove SKU codes + sentence case
   "CARDIGAN FW2026-031"    → "Cardigan"
   "vestido camisero largo" → "Vestido camisero largo"
   "trench coat fe2026-046" → "Trench coat"
---------------------------------------------------------------------- */

const SKU_TAIL_PATTERN = /\s+[A-Za-z]{2,3}\d{2,4}-\d+\s*$/;

export function stripSku(rawName) {
  if (!rawName) return rawName;
  return rawName.replace(SKU_TAIL_PATTERN, '').trim();
}

export function toSentenceCase(text) {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export function formatProductName(rawName) {
  if (!rawName) return rawName;
  const stripped = stripSku(rawName);
  return toSentenceCase(stripped) || rawName;
}
